class PageBannerStateService {
    constructor($rootScope) {
        this._pageStateBanners = {};

        $rootScope.$on('$locationChangeStart', () => {
            this.clearPageBannersState();
        });
    }

    setTobaccoBanner(hasTobaccoProduct) {
        this._pageStateBanners.setTobaccoBanner = hasTobaccoProduct;
    }

    getPageBannerState() {
        return this._pageStateBanners;
    }

    clearPageBannersState() {
        this._pageStateBanners = {};
    }
}

PageBannerStateService.$inject = ['$rootScope'];

module.exports = PageBannerStateService;



// WEBPACK FOOTER //
// ./src/shop/banners/pagebanner-state.service.js